export default {
  "cgu": {
    "heroTitle": "Conditions Générales d'Utilisation",
    "lastUpdated": "Dernière mise à jour : 3 août 2026",
    "sections": [
      {
        "title": "1. Préambule",
        "paragraphs": [
          "Les présentes Conditions Générales d'Utilisation (ci-après « CGU ») régissent l'accès et l'utilisation du site internet is-telecom.co (ci-après « le Site »), édité par la société IS TELECOM, société enregistrée au Bénin, dont le siège social est situé à Cotonou, Bénin.",
          "En accédant au Site et en naviguant sur ses pages, l'utilisateur (ci-après « l'Utilisateur ») accepte sans réserve l'intégralité des présentes CGU. Si l'Utilisateur n'accepte pas ces conditions, il lui est demandé de ne pas utiliser le Site."
        ]
      },
      {
        "title": "2. Objet du Site",
        "paragraphs": [
          "Le Site a pour objet de présenter les activités, les services et les produits proposés par IS TELECOM dans les domaines suivants :"
        ],
        "list": [
          "Micro-réseaux photovoltaïques et électrification rurale",
          "Solutions de pompage solaire et d'irrigation",
          "Stockage d'énergie et batteries lithium",
          "Recharge de véhicules électriques",
          "Construction métallique et BTP",
          "Informatique, réseaux et systèmes de monitoring",
          "Audit et conseils énergétiques",
          "Télécommunication et infrastructures",
          "Transport et logistique"
        ],
        "paragraphsAfter": [
          "Le Site permet également aux Utilisateurs de demander un devis, de contacter IS TELECOM et de consulter des informations sur les projets réalisés par la société."
        ]
      },
      {
        "title": "3. Accès au Site",
        "paragraphs": [
          "L'accès au Site est gratuit et ouvert à tout Utilisateur disposant d'une connexion internet. IS TELECOM met en œuvre les moyens nécessaires pour assurer la disponibilité du Site 24 heures sur 24, 7 jours sur 7, sauf en cas de force majeure, de maintenance technique ou de mise à jour nécessitant une interruption temporaire.",
          "IS TELECOM se réserve le droit de modifier, suspendre ou interrompre l'accès au Site, en totalité ou en partie, sans préavis et sans que cela puisse donner lieu à une quelconque indemnisation."
        ]
      },
      {
        "title": "4. Propriété intellectuelle",
        "paragraphs": [
          "L'ensemble des éléments composant le Site (textes, graphismes, logos, icônes, images, vidéos, sons, logiciels, base de données, etc.) sont la propriété exclusive d'IS TELECOM ou de ses partenaires et sont protégés par les lois relatives à la propriété intellectuelle.",
          "Toute reproduction, représentation, modification, publication, adaptation ou exploitation, totale ou partielle, des éléments du Site, par quelque procédé que ce soit, sans l'autorisation préalable et écrite d'IS TELECOM, est strictement interdite et constituerait une contrefaçon sanctionnée par les articles L.335-2 et suivants du Code de la propriété intellectuelle."
        ]
      },
      {
        "title": "5. Utilisation du Site",
        "paragraphs": [
          "L'Utilisateur s'engage à utiliser le Site de manière loyale et conforme à sa destination. Il s'interdit notamment de :"
        ],
        "list": [
          "Utiliser le Site à des fins illicites ou frauduleuses",
          "Introduire des virus, chevaux de Troie, vers ou tout autre logiciel malveillant",
          "Perturber ou interrompre l'accès au Site ou à ses serveurs",
          "Collecter des données personnelles d'autres Utilisateurs sans leur consentement",
          "Diffuser des contenus diffamatoires, injurieux, obscènes ou contraires à l'ordre public"
        ]
      },
      {
        "title": "6. Liens hypertextes",
        "paragraphs": [
          "Le Site peut contenir des liens vers des sites internet tiers. IS TELECOM n'exerce aucun contrôle sur le contenu de ces sites et décline toute responsabilité quant à leur contenu, leur exactitude ou leur fonctionnement. L'activation de ces liens se fait sous la seule responsabilité de l'Utilisateur.",
          "Toute création de lien hypertexte vers le Site doit faire l'objet d'une autorisation préalable et écrite d'IS TELECOM. IS TELECOM se réserve le droit de demander la suppression de tout lien non autorisé."
        ]
      },
      {
        "title": "7. Responsabilité",
        "paragraphs": [
          "IS TELECOM s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées sur le Site. Toutefois, IS TELECOM ne peut garantir l'exhaustivité, l'exactitude ou l'absence d'erreur des informations fournies. L'Utilisateur est invité à vérifier l'exactitude des informations auprès d'IS TELECOM avant de prendre toute décision.",
          "IS TELECOM ne saurait être tenu responsable des dommages directs ou indirects résultant de l'utilisation du Site, de l'impossibilité d'y accéder, ou de la consultation de contenus provenant de sites liés."
        ]
      },
      {
        "title": "8. Données personnelles",
        "paragraphs": [
          "IS TELECOM collecte et traite les données personnelles des Utilisateurs conformément à sa Politique de Confidentialité, accessible sur le Site. L'Utilisateur est invité à consulter cette politique pour comprendre comment ses données sont collectées, utilisées et protégées."
        ]
      },
      {
        "title": "9. Cookies",
        "paragraphs": [
          "Le Site utilise des cookies et technologies similaires pour améliorer l'expérience de navigation, analyser le trafic et personnaliser le contenu. L'Utilisateur peut gérer ses préférences en matière de cookies via les paramètres de son navigateur."
        ]
      },
      {
        "title": "10. Modification des CGU",
        "paragraphs": [
          "IS TELECOM se réserve le droit de modifier les présentes CGU à tout moment, notamment pour s'adapter aux évolutions légales, réglementaires ou techniques. Les modifications entrent en vigueur dès leur publication sur le Site. L'Utilisateur est invité à consulter régulièrement les CGU pour prendre connaissance des éventuelles modifications."
        ]
      },
      {
        "title": "11. Droit applicable et juridiction compétente",
        "paragraphs": [
          "Les présentes CGU sont soumises au droit béninois. En cas de litige relatif à l'interprétation, l'exécution ou la validité des présentes CGU, les parties s'engagent à rechercher une solution amiable avant toute action judiciaire. À défaut d'accord amiable, les tribunaux compétents de Cotonou, Bénin, seront seuls compétents pour connaître du litige."
        ]
      },
      {
        "title": "12. Contact",
        "paragraphs": [
          "Pour toute question relative aux présentes CGU ou au fonctionnement du Site, l'Utilisateur peut contacter IS TELECOM aux coordonnées suivantes :"
        ]
      }
    ]
  }
};